import React from 'react';
import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const JavaScriptIcon = (props) => {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd">
        <path fill="#F7DF1E" d="M2 2h28v28H2z" />
        <path
          d="M20.809 23.875c.564.921 1.298 1.598 2.595 1.598 1.09 0 1.787-.545 1.787-1.298 0-.902-.715-1.222-1.915-1.747l-.658-.282c-1.899-.809-3.16-1.822-3.16-3.964 0-1.974 1.503-3.476 3.853-3.476 1.673 0 2.876.582 3.742 2.107l-2.049 1.315c-.45-.808-.937-1.127-1.693-1.127-.77 0-1.259.489-1.259 1.127 0 .79.489 1.11 1.618 1.598l.658.282c2.235.959 3.497 1.936 3.497 4.133 0 2.37-1.86 3.667-4.36 3.667-2.443 0-4.022-1.164-4.794-2.69l2.138-1.243zm-9.295.228c.414.733.79 1.353 1.694 1.353.864 0 1.41-.338 1.41-1.653v-8.947h2.63v8.983c0 2.724-1.597 3.964-3.928 3.964-2.107 0-3.327-1.09-3.948-2.403l2.142-1.297z"
          fill="#000"
          fillRule="nonzero"
        />
      </g>
    </SVG>
  );
};

export default JavaScriptIcon;
